/* The Baselines section's calls (designs/product-baselines.md BL14). Each
   answers the stored result, or throws the server's own reason. */
import type {
  ActionInput,
  BaselineContent,
  BaselineDetail,
  BaselineView,
  NewBaseline,
  TemplateBody,
  TemplateRevision,
} from "../../../../shared/baselines";
import { asJson } from "../../intake/api";

const post = async <T,>(url: string, body: object): Promise<T> =>
  asJson(
    await fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    }),
  );

const list = async <T,>(url: string, what: string): Promise<T[]> => {
  const v = await asJson<unknown>(await fetch(url));
  if (!Array.isArray(v)) throw new Error(`the ${what} came back in an unexpected shape`);
  return v as T[];
};

const one = (id: string): string => encodeURIComponent(id);

export const getBaselines = (productId: string): Promise<BaselineView[]> =>
  list(`/api/baselines?productId=${encodeURIComponent(productId)}`, "baseline list");
export const getTemplates = (): Promise<TemplateRevision[]> => list("/api/baseline-templates", "template list");
export const getBaseline = async (id: string): Promise<BaselineDetail> => asJson(await fetch(`/api/baselines/${one(id)}`));
export const getTemplate = (id: string): Promise<TemplateRevision[]> => list(`/api/baseline-templates/${one(id)}`, "template");

export const postBaseline = (input: NewBaseline): Promise<BaselineDetail> => post("/api/baselines", input);
export const postVersion = (id: string, basedOn: number, content: BaselineContent, changeNote: string): Promise<BaselineDetail> =>
  post(`/api/baselines/${one(id)}/versions`, { basedOn, content, changeNote });
export const postEvent = (id: string, version: number, input: ActionInput): Promise<BaselineDetail> =>
  post(`/api/baselines/${one(id)}/versions/${version}/events`, input);

export const postTemplate = (body: TemplateBody): Promise<TemplateRevision[]> => post("/api/baseline-templates", { body });
export const postTemplateRevision = (id: string, basedOn: number, body: TemplateBody): Promise<TemplateRevision[]> =>
  post(`/api/baseline-templates/${one(id)}/revisions`, { basedOn, body });

export const message = (e: unknown): string => (e instanceof Error ? e.message : String(e));
